import { AddItemText, CreateYourItemSubtitleText, ManualOrderEntryText } from "constants/text";
import { ManualOrderEntryBox } from "./ManualOrderEntry.styles";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { DialogTracking } from "components/Dialog/components/DialogTracking.ts";
import { useDialog } from "hooks/useDialog.ts";
import { useUserLocation } from "hooks/useUserLocation.ts";
import { useNavigate } from "react-router";

const ManualOrderEntry = () => {
	const { openDialog, closeDialog } = useDialog();
	const { isOrderDetailsPage } = useUserLocation();
	const navigate = useNavigate();

	return (
		<ManualOrderEntryBox>
			<h6>{ManualOrderEntryText}</h6>
			<span>{CreateYourItemSubtitleText}</span>
			<Button
				onClick={() => {
					if (isOrderDetailsPage) {
						navigate("/new-order/build-order");
						closeDialog();
					} else {
						openDialog({ dialogStatus: DialogTracking.MANUAL_ORDER_ENTRY });
					}
				}}
				variant="outlined"
				data-id="new-order-landing-page-add-item-button"
				data-testid="new-order-landing-page-add-item-button"
				startIcon={<AddIcon fontSize="small" />}
			>
				{AddItemText}
			</Button>
		</ManualOrderEntryBox>
	);
};

export default ManualOrderEntry;
